import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Linkify from 'react-linkify';
import ToggleIcon from './icons/ToggleIcon';
import translate from '../../commonComponents/translate';
import { useSanitize } from '../../services/customHooks';

function MoreInfo({
  contentId,
  title,
  motivationTitle,
  description: contentDescription,
  motivation,
  startCollapsed,
}) {
  const [isCollapsed, setIsCollapsed] = useState(startCollapsed);
  const description = useSanitize(contentDescription);
  const toggleCollapsed = () => setIsCollapsed(prev => !prev);

  useEffect(() => setIsCollapsed(startCollapsed), [contentId]);

  return (
    (description || motivation) && (
      <div className="course-more-information">
        <h2 style={{ marginBottom: '20px' }}>{title}</h2>
        {isCollapsed && description && (
          <div style={{ height: '80px', overflowY: 'hidden' }}>
            <div
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </div>
        )}
        <div
          className={cx('course-info-extra', {
            collapsed: isCollapsed,
          })}
        >
          <div className="row">
            {description && (
              <div
                className={motivation?.length > 0 ? 'col-lg-8' : 'col-lg-12'}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                  style={{ marginBottom: '5rem' }}
                />
              </div>
            )}
            {motivation && (
              <div className={description?.length > 0 ? 'col-lg-4' : 'col-12'}>
                <div
                  className="course-more-information-right-info"
                  style={{ height: '100%' }}
                >
                  <p>
                    <strong>{motivationTitle}</strong>
                  </p>
                  <Linkify>{motivation}</Linkify>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className={cx('academy-course-separator-horizontal', {
            collapsed: isCollapsed,
          })}
        />
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span
          className={cx('academy-course-arrow-toggle', {
            collapsed: isCollapsed,
          })}
          onClick={toggleCollapsed}
        >
          <ToggleIcon />
        </span>
      </div>
    )
  );
}

MoreInfo.propTypes = {
  contentId: PropTypes.string,
  title: PropTypes.string.isRequired,
  motivationTitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  motivation: PropTypes.string,
  startCollapsed: PropTypes.bool,
};

MoreInfo.defaultProps = {
  motivationTitle: '',
  motivation: '',
  startCollapsed: false,
  contentId: '',
};

export default translate(MoreInfo);
